import Vue from 'vue'
import VueRouter from 'vue-router'
import Dictionary from '@/components/Dictionary'
import Community from '@/components/Community'
import FullSetOfRules from '@/pages/FullSetOfRules'
import WordSystems from '@/pages/WordSystems'
import NotFound from '@/components/NotFound'
import FAQ from '@/components/FAQ'
import Textbook from '@/pages/Textbook'
import Reading from '@/components/Reading'
import Transliterations from '@/components/Transliterations'
//const Transliterations = () => import('@/components/Transliterations')
import Game from '@/components/Game'
import Crossword from '@/pages/Crossword'
import Comparison from '@/pages/Comparison'
import Updates from '@/pages/Updates'
import Combinations from '@/pages/Combinations'
import Test from '@/pages/Test'
import Elements from '@/pages/Elements'
import Origins from '@/pages/Origins'

Vue.use(VueRouter)

const routes = [
	{path: '/dict/:word?', name: 'dict', component: Dictionary,  meta: {title: 'Dictionary'} },
	{path: '/faq', component: FAQ,  meta: {title: 'FAQ'} },
	{path: '/community', component: Community, meta: {title: 'Community'} },
	{path: '/textbook/:lesson?', component: Textbook, meta: {title: 'Textbook'}},
	{path: '/transliterations/:lang?', component: Transliterations, meta: {title: 'Transliterations'}},
	{path: '/full-set-of-rules', component: FullSetOfRules, meta: {title: 'Full Set of Rules'} },
	{path: '/word-systems', component: WordSystems, meta: {title: 'Word systems'} },
	{path: '/reading/:story?', component: Reading, meta: {title: 'Reading'}},
	{path: '/game', component: Game, meta: {title: 'Game'}},
	{path: '/crossword', component: Crossword, meta: {title: 'Crossword'}},
	{path: '/comparison/:lang?', component: Comparison, meta: {title: 'Comparison'}},
	{path: '/updates', component: Updates, meta: {title: 'Updates'}},
	{path: '/origins', component: Origins, meta: {title: 'Origins'}},
	{path: '/combinations', component: Combinations, meta: {title: 'Combinations'}},
	{path: '/elements', component: Elements, meta: {title: 'Elementary words'}},
	{path: '/test', component: Test, meta: {title: 'Test'}},
	{path: '/', redirect: '/textbook' },
	{path: '*', component: NotFound, meta: {title: 'Page Not Found'} },
]

const router = new VueRouter({
	mode: 'hash',
	//mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) return savedPosition;
		else return { x: 0, y: 0 };
	}

})

export default router
